import { CircleAlert, CircleCheck } from "lucide-react";

import EntryDetails from "components/LogItem/elements/EntryDetails";

export const LEAD_EVENTS = {
  meta_conversion_event_sent: {
    title: "Conversion Event Sent",
    icon: CircleCheck,
    message: ({ info }) => (
      <>
        <p>The system sent the {info.event_name} event to Meta.</p>
        <EntryDetails rows={[{ label: "Dataset", value: info.dataset_name }]} />
      </>
    ),
  },
  meta_conversion_event_failed: {
    title: "Conversion Event Failed",
    icon: CircleAlert,
    message: ({ info }) => (
      <>
        <p>The system could not send the {info.event_name} event to Meta.</p>
        <EntryDetails
          rows={[
            { label: "Dataset", value: info.dataset_name },
            { label: "Reason", value: info.error },
          ]}
        />
      </>
    ),
  },
};
